/**
 * File Upload Configuration Constants
 *
 * These constants define the limits for file uploads in the chat system.
 * Limits are calculated based on Claude's token limits to prevent API errors.
 *
 * Token estimation:
 * - Claude Sonnet supports ~200k tokens
 * - 1MB of text ≈ ~250k tokens (conservative estimate)
 * - Images and PDFs have variable token costs depending on content
 * - We reserve tokens for conversation context and responses
 */

/**
 * Maximum number of files that can be attached at once
 */
export const MAX_FILES = 20;

/**
 * Maximum total size for all files combined (in bytes)
 * 5MB total - Conservative limit to stay well under token limits
 * considering conversation context and response generation
 */
export const MAX_TOTAL_SIZE = 5 * 1024 * 1024; // 5MB in bytes

/**
 * Maximum size for a single file (in bytes)
 * 2MB per file - Ensures individual files don't consume too many tokens
 */
export const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2MB in bytes

/**
 * Allowed file extensions for uploads
 */
export const ALLOWED_EXTENSIONS = [
  'pdf',
  'jpg',
  'jpeg',
  'png',
  'txt',
  'csv',
  'json',
  'xml'
] as const;

/**
 * Type for allowed extensions
 */
export type AllowedExtension = typeof ALLOWED_EXTENSIONS[number];
